import { AppShell } from "@/components/shared/AppShell";

export function BookmarksPage() {
  return (
    <AppShell>
      <h1 className="font-display text-2xl font-semibold sm:text-3xl">Bookmarks</h1>
      <p className="mt-2 max-w-lg font-body text-sm text-ink/60">Board moments and explanations you saved during a lesson.</p>
      <div className="glass mt-6 rounded-2xl p-8 font-body text-sm text-ink/50">
        Phase 0 placeholder — real content wires up in Phase 3 per the roadmap.
      </div>
    </AppShell>
  );
}
